<script setup lang="ts">
//@ts-ignore
useHead({
  title: "Blog",
});
const router = useRouter();
const route = useRoute();

const categoryFilter = computed(() => {
  const filter = route.query["filter"];
  return typeof filter === "string" ? filter : null;
});

const { data: posts } = await useFetch<Post[]>("/api/blog/posts", {
  query: {
    filter: categoryFilter,
  },
  watch: [categoryFilter],
});
const { data: categories } = await useFetch<PostCategory[]>("/api/blog/categories", {});
const getPostCountByCategory = (slug: string) => {
  return (
    posts.value?.filter((post) => {
      return post.categoria.slug == slug;
    }).length ?? 0
  );
};
const categoryItems = categories.value?.map((cat) => ({
  name: cat.title,
  count: getPostCountByCategory(cat.slug),
  link: router.currentRoute.value.path + `?filter=${cat.slug}`,
}));
const categoryItemsAll = {
  name: "All",
  count: -1,
  link: "/blog",
};
categoryItems?.unshift(categoryItemsAll);

onMounted(async () => {
  if (import.meta.client) {
    // @ts-ignore
    // $(".blog-masonry").imagesLoaded(async () => {
    //   /// @ts-ignore
    //   var $blogGrid = $(".blog-masonry");
    //   $blogGrid.isotope({
    //     itemSelector: ".post-grid",
    //     percentPosition: true,
    //   });
    // });
  }
  if (import.meta.client) {
    setTimeout(async () => {
      await import("jquery");
      const Isotope = (await import("isotope-layout")).default;
      const imagesLoaded = (await import("imagesloaded")).default;

      // @ts-ignore
      imagesLoaded(".masonry", async () => {
        /// @ts-ignore
        await nextTick();
        // const isotope = new Isotope(".masonry", {
        //   // main isotope options
        //   itemSelector: ".masonry-item",
        //   // set layoutMode
        //   layoutMode: "masonry",
        //   // options for cellsByRow layout mode
        // });

        // setupFilters(isotope);
      });
    }, 500);
  }
});
</script>
<template>
  <div class="content">
    <Breadcumb :title="'Blog'" :subtitle="'Read my latest articles.'" :items="[{ text: 'Home', href: '/' }]" :to="{ text: 'Blog', href: '/blog' }" />
    <!-- Theme standard row start for blog -->
    <div class="xboot-standard-row gray-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-12">
            <!-- <BlogSingleWidgetSearch title="Search" :callback="() => {}" /> -->

            <BlogSingleWidgetItems title="Categories" :items="categoryItems" />
          </div>

          <div class="col-lg-9 col-md-8 col-sm-12">
            <div class="row">
              <div class="blog-masonry masonry">
                <BlogPost class="h-full col-lg-4 col-md-6" v-for="post in posts" :key="post.documentId" :post="post" />

                <!-- <BlogPost
                  v-if="false"
                  v-for="n in 6"
                  :key="n"
                  :title="'Blog Post title ' + n"
                  :imageUrl="`https://picsum.photos/600/400?grayscale&random=${n}`"
                  :author="'Admin'"
                  :date="'20 Jan, 2070'"
                  :category="'Graphic'"
                  :excerpt="'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur ea, quis magnam deserunt eius incidunt repellat molestiae maiores, quidem cumque!'"
                  :slug="'post-' + n"
                />

                <BlogPost
                  title="Post audio"
                  author="Admin"
                  date="20 Jan, 2070"
                  category="Graphic"
                  excerpt="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur ea, quis magnam deserunt eius incidunt repellat molestiae maiores, quidem cumque!"
                  slug="post-audio"
                  :media="true"
                >
                  <template #media>
                    <iframe
                      src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/230186723&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true"
                    ></iframe>
                  </template>
                </BlogPost>

                <BlogPost
                  title="Post no image"
                  author="Admin"
                  date="20 Jan, 2070"
                  category="Graphic"
                  excerpt="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur ea, quis magnam deserunt eius incidunt repellat molestiae maiores, quidem cumque!"
                  slug="post-no-img"
                >
                </BlogPost> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Theme standard row end for blog -->
  </div>
</template>
